<template>
  <div class="py-16 lg:py-24">
    <div class="bg-theme-light rounded-lg py-10 text-center">
      <img src="@/assets/images/emailVerified.svg" class="mx-auto">
      <div class="py-6 text-lg font-medium px-5">
        <p class="text-blue pb-2 leading-6 text-xl">
          Your email is verified & your application is under review!
        </p>
        <p class="leading-7 pt-2">
          Thank you for your application. We are reviewing your application and we will notify you by email. <br > Your account settings on the website will be available for update soon.
        </p>
        <p class="pt-5">
        </p>
      </div>
      <p class="text-lg font-medium pt-4"> <a :href="contactUrl" style="cursor: pointer;" class="text-blue underline underline-offset-2"> Contact Us</a> | <a @click="signOut" style="cursor: pointer;" class="text-blue underline underline-offset-2">Logout</a></p>
    </div>
  </div>
</template>
<script>
import store from '@/store/index'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'AccountReview',
  beforeRouteEnter: async (to, from, next) => {
    document.title = 'Thank you - BuyHive'
    console.log('Account review', store.getters, store.getters.getIsEmailVerified, store.getters.getUserAuthInfo.profileVerified)
    console.log('account review condition', (store.getters.getIsEmailVerified && store.getters.getUserAuthInfo.profileVerified))
    if (!store.getters.isUserLoggedIn || store.getters.getUserAuthInfo.role === 'buyer') {
      // next({ name: 'Home' })
      console.log('account review || if')
      window.location.href = `${process.env.VUE_APP_SERVER_BASE_URL}`;
    } else if (!store.getters.getIsEmailVerified) {
      console.log('account review || else if')
      next({ name: 'EmailVerification' })
    }else if (store.getters.getIsEmailVerified && store.getters.getUserAuthInfo.profileVerified) {
      console.log('account review || else if 2')
      next({ name: 'ProfileVerified' })
    } else {
      console.log('account review || else')
      next()
    }
  },
  data() {
    return {
      contactUrl: `${process.env.VUE_APP_SERVER_BASE_URL}/buy/contact-us?enquiry_type=Expert Sourcing`
    }
  },
  computed: {
    ...mapGetters ([ 'getUserAuthInfo', 'getIsEmailVerified', 'getIsProfileActivated' ])
  },
  methods: {
    ...mapActions ([
      'logout'
    ]),
    async signOut() {
      await this.logout()
      // this.$router.push({ name: 'Home' })
      window.location = process.env.VUE_APP_SERVER_BASE_URL
    },
  }
};
</script>